import TabPage from "./../factories/tab-page";
import BaseViewModel from "./../factories/base-view-model2";
import * as ko from "knockout";
import Bao from "./../services/bao-service";
import BaoDialog from "./../factories/bao-dialog";
class PurchaseType extends BaseViewModel {
    Name = ko.observable();
    public constructor(tabPage: TabPage) {
        super(tabPage);
    }
    public CompleteCheck(): JQueryPromise<boolean> | boolean {
        var completed: boolean;
        completed = true;
        if (this.Name() === "" || this.Name() === null) {
            completed = false;
        }
        if (!completed) {
            var baoDialog = new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
        }
        return completed;
    }
    public InitUrl(): string {
        return "PurchaseType/Init";
    }
    public init(): JQueryPromise<void> {
        return super.init();
    }
}
export default PurchaseType;